export default "__VITE_ASSET__47f09e5d__"